<template>
    <div class="flex truncate"  :class="small ? 'flex-col ':''">
        <div class="mr-3">
            <vs-dropdown >
                <vs-avatar
                    v-if="avatar"
                    class="m-0"
                    :src="avatar"
                    size="35px"
                />
                <!-- element that initializes the dropdown -->

                <vs-dropdown-menu  style="z-index: 99999999" v-if="profile">
                    <!-- items and elements within the menu or custom dropdown -->
                    <div class="p-4 flex" >
                        <div>
                            <router-link :to="{name: 'user-info', query: {id: profile.uid}}">
                            <vs-avatar class="m-0" :src="avatar" size="55px" />
                            </router-link>
                        </div>
                        <div class="flex-column ml-4">
                            <div>
                                <span>
                                    {{
                                        profile !== undefined
                                            ? profile.lastName
                                            : ""
                                    }}
                                </span>
                                <span>
                                    {{
                                        profile !== undefined
                                            ? profile.firstName
                                            : ""
                                    }}
                                </span>
                                <span>
                                    {{
                                        profile !== undefined
                                            ? profile.middleName
                                            : ""
                                    }}
                                </span>
                            </div>
                            <div v-if="profile != undefined">
                                <div v-if="(profile.email != null)&&(profile.phone != '')">
                                    <span class="font-bold">Email: </span>
                                    <span>{{
                                        profile.email
                                    }}</span>
                                </div>
                                <div v-if="(profile.phone != null)&&(profile.phone != '')">
                                    <span class="font-bold">Телефон: </span>
                                    <span>{{
                                       profile.phone
                                    }}</span>
                                </div>
                                <div>
                                    <vs-button
                                        v-if="btnMessage && isNotMe"
                                        color="primary"
                                        @click="sendMessage()"
                                        icon-pack="feather"
                                        icon="icon-message-square"
                                        size="small"
                                        class="mt-2"
                                        type="filled">
                                        {{$t('write_a_message')}}
                                    </vs-button>
                                </div>
                                 <!-- <vs-button class="mt-2" @click="sendMessage()" v-if="btnMessage && isNotMe"
                                  color="primary" size="small" type="filled">{{$t('write_a_message')}}</vs-button> -->
                            </div>
                        </div>
                    </div>

                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <div class="leading-tight truncate">
            <p class="font-medium" v-if="title">{{ title }}</p>

            <p class="font-medium  truncate" v-else-if="profile['last_name_'+$i18n.locale] === null">{{ profile['lastName'] }}
                  {{ profile['firstName'] }}  {{ profile['middleName'] }} </p>

            <p class="font-medium  truncate" v-else-if="!small">{{ profile['last_name_'+$i18n.locale] }}
                  {{ profile['first_name_'+$i18n.locale] }}  {{ profile['middle_name_'+$i18n.locale] }} </p>

            <p>{{ profile['lastName'] }} {{ profile['firstName'] }} {{ profile['middleName'] }}</p>

            <p class="text-sm truncate" v-if="small">
                  {{ profile['first_name_'+$i18n.locale] }}   </p>

            <p class="text-sm truncate" v-if="small &&  profile['firstName']">
                {{ profile['firstName'] }}   </p>

            <span class="text-xs" v-if="subtitle">{{ subtitle }} </span>

        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    props: {
        avatar: [String],
        title: [String],
        subtitle: [String],
        profile: [Object],
        small: [Boolean],
        btnMessage: [Boolean]
    },

    methods: {
        sendMessage() {
            this.$router.push({name: 'chat', query: {user: this.profile.profileId}})
        },
    },
    computed: {
        ...mapGetters({
            USER: "user/getUser",
        }),
        isNotMe(){
            return this.USER.profileId !== this.profile.profileId
        }
    },

};
</script>

<style>
</style>
